import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toggleModal, getCurrencySign } from "../store/common";
import { clearCustomerCart } from "../store/customer";
import { importCart } from "../store/cart";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import { Table } from "reactstrap";

const getTotal = items => {
  let total = 0;
  items.map(
    item => (total = Number(total) + Number(item.price) * Number(item.quantity))
  );
  return total;
};

const cartItemTable = (cartItems, translate, currencySign) => (
  <Table>
    <thead>
      <tr>
        <th>Id</th>
        <th>{translate("molecules.containers.productsFilter.code")}</th>
        <th>{translate("molecules.containers.productsFilter.flex_name")}</th>
        <th>{translate("molecules.containers.productsFilter.quantity")}</th>
        <th>{translate("molecules.containers.productsFilter.price")}</th>
      </tr>
    </thead>
    <tbody>
      {cartItems &&
        cartItems.map(item => (
          <tr>
            <td>{item.id}</td>
            <td>{item.code}</td>
            <td>{item.title}</td>
            <td>{item.quantity}</td>
            <td>
              {item.price} {currencySign}
            </td>
          </tr>
        ))}
    </tbody>
    <tfoot>
      <tr>
        <td colSpan="4">
          <b>Total</b>
        </td>
        <td>
          <b>
            {cartItems && cartItems.length > 0 && getTotal(cartItems)}{" "}
            {currencySign}
          </b>
        </td>
      </tr>
    </tfoot>
  </Table>
);

const CustomerCartModal = ({
  toggleModal,
  getModalStatus,
  cartItems,
  translate,
  importCartProduct,
  currencySign,
  currentLanguage
}) => (
  <Modal
    size="lg"
    className="product_modal"
    isOpen={getModalStatus}
    toggle={() => toggleModal("customer_cart", false)}
    centered
  >
    <ModalHeader>
      {" "}
      <h1>{translate("containers.customerCartModal.title")}</h1>
    </ModalHeader>
    <ModalBody>
      {cartItems && cartItemTable(cartItems, translate, currencySign)}
    </ModalBody>
    <ModalFooter>
      <Button
        color="btn btn-secondary btn-danger"
        onClick={() => toggleModal("customer_cart", false)}
      >
        {translate("containers.productModalContainer.close")}
      </Button>
    </ModalFooter>
  </Modal>
);

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).id || 1,
  getModalStatus: state.common.modals
    ? state.common.modals.customer_cart
    : null,
  cartItems: state.customer.cart,
  currencySign: getCurrencySign(state.common.user.currency.sign)
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => {
    dispatch(toggleModal(modalName, action));
    dispatch(clearCustomerCart());
  },
  importCartProduct: () => dispatch(importCart())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerCartModal);



// WEBPACK FOOTER //
// ./src/containers/CustomerCartModal.js